import type { ReactNode } from "react";

export type ComboboxOption = {
    value: string;
    label?: string;
    keywords?: string[];
    search_node?: ReactNode;
    /** Listed but not selectable. */
    disabled?: boolean;
    /** Shown under the label (the reason an option is disabled, say). */
    description?: string;
};

export function deduplicateComboboxOptions(options: ComboboxOption[]): ComboboxOption[] {
    const byValue = new Map<string, ComboboxOption>();
    for (const option of options) {
        if (!byValue.has(option.value)) byValue.set(option.value, option);
    }
    const unique = [...byValue.values()];
    const labelCounts = unique.reduce((counts, option) => {
        const label = option.label ?? option.value;
        counts.set(label, (counts.get(label) ?? 0) + 1);
        return counts;
    }, new Map<string, number>());

    return unique.map(option => {
        const label = option.label ?? option.value;
        return labelCounts.get(label) === 1 ? option : { ...option, label: `${label} · ${option.value}` };
    });
}
